import { apiService, handleResponse } from '@/services/apiService';

export class UserRepository {
    async login(credentials: { email: string; password: string }) {
        const response = await apiService.post(`/v1/params/login`, credentials);
        return handleResponse(response);
    }
    async logout() {
        const response = await apiService.post(`/logout`);
        return handleResponse(response);
    }

    async getUser() {
        const response = await apiService.get(`/v1/user`);
        return handleResponse(response);
    }

    async connectModule(token: string) {
        const response = await apiService.get(`/v1/modules/access/${token}`);
        return handleResponse(response);
    }
}
